import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/page/login/login';
import NotFound from '@/page/errorPage/404';
import Forbidden from '@/page/errorPage/403';
import Layout from '@/page/layout/index';
import store from '@/store/index';

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push (location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
};

//提示和设备检测
// const home = () => import('@/page/home/index');
const detection = () => import('@/page/home/detection');
const curriculumAreas = () => import('@/page/home/curriculumAreas');

//创作工具
const toolsManage = () => import('@/page/home/toolsManage');

//课时列表
const classList = () => import('@/page/classList/index');
const classListContent = () => import('@/page/classList/component/classListContent');
const classListDetail = () => import('@/page/classList/component/classListDetail');
const classAssessment = () => import('@/page/classList/component/classAssessment');
const uploading = () => import('@/page/classList/component/uploading');

//我的课程
const myCourse = () => import('@/page/myCourse/index');
const myCourseList = () => import('@/page/myCourse/component/myCourseList');

//我的作品
const myWork = () => import('@/page/myWork/index');
const myWorkMain = () => import('@/page/myWork/component/myWorkMain');

//随堂习题
const classExercises = () => import('@/page/classExercises/index');
const classExercisesMain = () => import('@/page/classExercises/component/classExercisesMain');

//学习报告
const studyReport = () => import('@/page/studyReport/index');
const studyReportMain = () => import('@/page/studyReport/component/studyReportMain');
var router = new Router({
    routes: [
        {
            path: '/login',
            component: Login
        },
        {
            path: '/',
            component: Layout,
            name: 'container',
            meta: {
                requiresAuth: true,
                name: '首页'
            },
            children: [
                // {
                //     path: '/home',
                //     name: 'home',
                //     component: home,
                //     meta: {
                //         name: '首页'
                //     }
                // },
                {
                    path: '/detection',
                    name: 'detection',
                    component: detection,
                    meta: {
                        name: '检测'
                    }
                },
                {
                    path: '/curriculumAreas',
                    name: 'curriculumAreas',
                    component: curriculumAreas,
                    meta: {
                        name: '课程区域'
                    },
                },
                {
                    path: '/toolsManage',
                    name: 'toolsManage',
                    component: toolsManage,
                    meta: {
                        name: '创作工具',
                    }
                },
                {
                    path: '/classList',
                    name: 'classList',
                    component: classList,
                    meta: {
                        name: '课时列表'
                    },
                    redirect: { name: 'classListContent' },
                    children: [{
                        path: 'classListContent',
                        name: 'classListContent',
                        component: classListContent,
                        meta: {
                            name: '课时列表'
                        },
                    }, {
                        path: 'classListDetail',
                        name: 'classListDetail',
                        component: classListDetail,
                        meta: {
                            name: '课时列表详情'
                        }
                    }, {
                        path: 'classAssessment',
                        name: 'classAssessment',
                        component: classAssessment,
                        meta: {
                            name: '随堂测评'
                        }
                    },
                    {
                        path: 'uploading',
                        name: 'uploading',
                        component: uploading,
                        meta: {
                            name: '上传作品'
                        }
                    }]
                },
                {
                    path: '/myCourse',
                    name: 'myCourse',
                    component: myCourse,
                    meta: {
                        name: '我的课程'
                    },
                    redirect: { name: 'myCourseList' },
                    children: [{
                        path: 'myCourseList',
                        name: 'myCourseList',
                        component: myCourseList,
                        meta: {
                            name: '我的课程'
                        }
                    }]
                },
                {
                    path: "/myWork",
                    name: 'myWork',
                    component: myWork,
                    meta: {
                        name: '我的作品'
                    },
                    redirect: { name: 'myWorkMain' },
                    children: [{
                        path: 'myWorkMain',
                        name: 'myWorkMain',
                        component: myWorkMain,
                        meta: {
                            name: '我的作品'
                        }
                    }]
                },
                {
                    path: "/classExercises",
                    name: 'classExercises',
                    component: classExercises,
                    meta: {
                        name: '易错题'
                    },
                    redirect: { name: 'classExercisesMain' },
                    children: [{
                        path: 'classExercisesMain',
                        name: 'classExercisesMain',
                        component: classExercisesMain,
                        meta: {
                            name: '易错题'
                        }
                    }]
                },
                {
                    path: "/studyReport",
                    name: 'studyReport',
                    component: studyReport,
                    meta: {
                        name: '学习报告'
                    },
                    redirect: { name: 'studyReportMain' },
                    children: [{
                        path: 'studyReportMain',
                        name: 'studyReportMain',
                        component: studyReportMain,
                        meta: {
                            name: '学习报告'
                        }
                    }]
                }
            ]
        },
        {
            path: '/403',
            component: Forbidden
        },
        {
            path: '*',
            component: NotFound
        }
    ]
});
export default router;
router.beforeEach((to, from, next) => {
    if (!store.state.UserToken) {
        if (
            to.matched.length > 0 &&
            !to.matched.some(record => record.meta.requiresAuth)
        ) {
            next();
        } else {
            next({ path: '/login' });
        }
    } else {
        if (to.path !== '/login') {
            next();
        } else {
            next(from.fullPath);
        }
    }
});



// WEBPACK FOOTER //
// ./src/router/index.js